module.exports = __webpack_public_path__ + "img/appIcon-menu--Revenue--active.04dbc24d.svg";